import React from "react";
import { connect } from "react-redux";
import {
  setAuth,
  setPODataInfo,
  setPODataInfoProperty,
  setI18N
} from "../js/actions/index";

import { withRouter } from "react-router-dom";

import {
  Container,
  Col,
  Row,
  Button,
  Table,
  Form,
  Modal,
  ListGroup,

  DropdownButton,
  Dropdown,
} from "react-bootstrap";

import {
  Basket,
  Box,
  Cash,
  ArrowLeftCircle,
  ExclamationCircle,
  XCircle,
  Binoculars,
  ExclamationTriangleFill
} from "react-bootstrap-icons";

import moment from "moment";
import "react-dates/initialize";
import {
  SingleDatePicker,
} from "react-dates";
import "react-dates/lib/css/_datepicker.css";

import NavbarComponent from "../components/NavbarComponent";
import LoadingComponent from "../components/LoadingComponent";
import ServerErrorComponent from "../components/ServerErrorComponent";
import AuthErrorComponent from "../components/AuthErrorComponent";
import AlertErrorComponent from "../components/AlertErrorComponent";
import AlertComponent from "../components/AlertComponent";
import AlertSuccessComponent from "../components/AlertSuccessComponent";
import LogsModalComponent from "../components/LogsModalComponent";

import {
  formatCurrency,
  getSearchTermMatch,
  uint8ToBase64,
  dataURItoBlob,
  packagingUnitLabel,
  toFixed
} from "../js/global";

import FileSaver from "file-saver";

import { Formik } from "formik";
import * as Yup from "yup";

import {
  NO_USER_FOUND,
  FAILED_AUTHENTICATE_TOKEN,
} from "../constants/ApiResult";

import {
  PRODUCTS, UNITS, BRANCHES, DEPARTMENTS, SUPPLIERS, UAT
} from "../constants/GlobalConstant";

import {
  geti18nGoods
} from "../services/i18n";

import {
//    getInventoryBranchMapping,
    getSupplierInventory
} from "../services/Supplier";

import I18N from "../js/i18n";
import {i18n} from "../js/global";

/*
const services = {  
    getInventoryBranchMapping,
    getSupplierInventory,
    geti18nGoods
  };
*/

const utf8 = require('utf8');
const orientation = window.matchMedia("(max-width: 700px)").matches ? 'vertical' : 'horizontal';

/*
const schema = Yup.object({
  emailTo: Yup.string().email().required(),
  emailMessage: Yup.string().required(),
});
*/

const validationSchema = Yup.object().shape({
  emailTo: Yup.string()
    .required("*Email is required")
    .email("*Email is invalid"),
  emailMessage: Yup.string().required("*Message is required"),
});

const axios = require("axios").default;

//const queryString = require("query-string");

const DECIMALS_5 = 5;
const DECIMALS_10 = 10;

function mapDispatchToProps(dispatch) {
  return {
    setAuth: (auth) => dispatch(setAuth(auth)),
    setPODataInfo: (data) => dispatch(setPODataInfo(data)),
    setPODataInfoProperty: (data) => dispatch(setPODataInfoProperty(data)),
    setI18N: (data) => dispatch(setI18N(data))
  };
}

class PurchaseOrder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      addProductModalShow: false,
      addProductModalShowAttribute: false,
      advancedSearchProduct: true,
      advancedSearchSupplier: true,
      data: "",
      dataInfo: "",
      dataProducts: "",
      dataDepartments: "",
      dataStorage: "",
      productSearchTerms: "",
      productsAdd: [],
      productsAddConfirm: [],
      emailModalShow: false,
      emailModalFormInvalid: true,
      emailModalProcessing: false,
      showAlertModal: false,
      alertModalConfig: {
        title: "",
        warning: "",
        function: "",
      },
      showUndoModal: false,
      isSavePurchaseOrder: false,
      poTouched: false,
      isLoading: true,
      authError: false,
      serverError: false,
      errorAPI: false,
      isPrint: false,
      saveSuccessful: false,
      confirmPOSuccessful: false,
      rejectPOSuccessful: false,
      addProductSuccessful: false,
      orderNames: "",
      isUpdated: false,
      focused: false,
      isLogs: false,
      warnings:{
        sellPrice:[],
        inactive:[]
      },
      i18n:{}
    };
  }

  componentDidMount = async () => {
    console.log('Component did mount..');
    if (window.location.pathname.indexOf("/purchase-order/share/") !== -1) {
      this.props
        .setAuth({
          mode: "supplier",
          isLogin: false,
          token: this.props.match.params.poId,
          businessId: 0,
          operatorId: 0,
          supplierId: 0,
          isSupplier: true,
        })
        .then(() => {
          this.getPODetails();
        });
    } else {
      this.getPODetails();
    }

    this.updatePredicate();
    window.addEventListener("resize", this.updatePredicate);

    // I18N temporary env condition
    if(process.env.REACT_APP_ENV !== UAT) {
      const i18nGoods = await this.geti18nGoods();

      this.props.setI18N({
        property:PRODUCTS,
        value:i18nGoods.data.data
      }).then( () => {
        this.seti18n();
      });
    } else {
      this.seti18n();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updatePredicate);
  }

  componentDidUpdate() {
    if (!this.state.isUpdated) {
      this.setState({
        isUpdated: true,
      });
    }
  }

  updatePredicate = () => {
    this.setState({
      isDesktop: window.innerWidth >= 768,
    });
  };

  isShareView = () => {
    if (this.props.readOnly) {
      return true;
    }
    return false;
  };

  isReadOnly = () => {
    if (
      this.props.readOnly ||
      (!this.props.readOnly && this.state.data.State !== 1)
    ) {
      return true;
    }
    return false;
  };

  isPrint = () => {
    if (this.state.isPrint) {
      return true;
    }
    return false;
  };

  handleGoBack = () => {
    this.props.history.goBack();
  };

/*
API
*/

  // Error API
  handleErrorAPI = (err) => {
    if(err) {
        console.error(err);
    }
    this.setState({
        errorAPI:true,
        isLoading:false
    });
  }

  // Server Error API
  handleServerErrorAPI = (err) => {
    if(err) {
        console.error(err);
    }
    this.setState({
        serverError:true,
        isLoading:false
    });
  }

// (GET) i18n Goods

geti18nGoods = () => {
    try {
      const props = {
        token: this.props.auth.token,
        supplierId: this.props.match.params.supplierId
      };
      return geti18nGoods(props);
    } catch (err) {
      this.handleServerErrorAPI(err);
    }    
}

// (GET) Supplier Inventory

  getSupplierInventory = () => {
    try {
      const props = {
        token: this.props.auth.token,
        branchId: this.props.match.params.branchId,
        supplierId: this.props.match.params.supplierId,
      };
      const response = getSupplierInventory(props);

      return response;
    } catch (err) {
      this.handleServerErrorAPI(err);
    }
  }

  getPODetails = () => {
    const supplierId = this.props.match.params.supplierId;
    const branchId = this.props.match.params.branchId;
    const poId = this.props.match.params.poId;
    const storageDate = this.props.match.params.storageDate;

    axios
      .all([
        axios.get(
          `${process.env.REACT_APP_API_URL}/api/getPurchaseOrdersItemsBySupplierId/`,
          {
            params: {
              id: supplierId,
              branchId: branchId,
              poId: poId,
              storageDate: storageDate,
              state: 1,
            },
            headers: {
              Authorization: "Basic " + this.props.auth.token,
            },
          }
        ),
        axios.get(
          `${process.env.REACT_APP_API_URL}/api/getDepartment/${branchId}`,
          {
            headers: {
              Authorization: "Basic " + this.props.auth.token,
            },
          }
        ),
        axios.get(
          `${process.env.REACT_APP_API_URL}/api/getStorage/${branchId}`,
          {
            headers: {
              Authorization: "Basic " + this.props.auth.token,
            },
          }
        ),
        axios.get(
          `${process.env.REACT_APP_API_URL}/api/getBranchByBranchId/${branchId}`,
          {
            headers: {
              Authorization: "Basic " + this.props.auth.token,
            },
          }
        ),
        axios.get(
          `${process.env.REACT_APP_API_URL}/api/getSupplier/${supplierId}`,
          {
            headers: {
              Authorization: "Basic " + this.props.auth.token,
            },
          }
        ),
      ])
      .then(
        axios.spread(
          (
            getPurchaseOrdersItemsBySupplierId,
            getDepartment,
            getStorage,
            getBranchByBranchId,
            getSupplier
          ) => {
            let data = {};
            let purchaseOrderItemList = [];
            let POId = [];

            // invalid link
            /*if(getPurchaseOrdersItemsBySupplierId.data.data.length === 0) {
                this.props.history.push(`/My404`);
            }*/

            if (
              [NO_USER_FOUND, FAILED_AUTHENTICATE_TOKEN].indexOf(
                getPurchaseOrdersItemsBySupplierId.data.result
              ) > -1
            ) {
              this.setState({
                isLoading: false,
                authError: true,
              });
              return;
            }

            if (
              typeof getPurchaseOrdersItemsBySupplierId.data.data ===
                "object" &&
              typeof getDepartment.data.data === "object" &&
              typeof getStorage.data.data === "object" &&
              typeof getBranchByBranchId.data.data === "object" &&
              typeof getSupplier.data.data === "object"
            ) {
              getPurchaseOrdersItemsBySupplierId.data.data.forEach(
                (product, index) => {
                  POId.push(product.POId);

                  let itemIndex = purchaseOrderItemList.findIndex(
                    (item) =>
                      item.GoodsId === product.GoodsId &&
                      item.GoodsFormatId === product.GoodsFormatId
                  );

                  if (itemIndex === -1) {
                    let GoodsFormatName = product.gfGoodsFormatName
                      ? product.gfGoodsFormatName
                      : product.GoodsFormatName;
                      
                    /*let salesPrice = product.gfSellPrice
                      ? product.gfSellPrice
                      : product.SellPrice;
                    */

                      let salesPrice = product.salesPrice;

                      let GoodsFormatNum = product.gfGoodsFormatNum
                      ? product.gfGoodsFormatNum
                      : product.GoodsFormatNum;

                    purchaseOrderItemList.push({
                      POIId: product.POIId,
                      POIIds: [product.POIId],
                      GoodsName: product.GoodsName,
                      GoodsCode: product.GoodsCode,
                      GoodsFormatName: GoodsFormatName,
                      GoodsFormatNum: GoodsFormatNum,
                      GoodsFormatId: product.GoodsFormatId,
                      GoodsId: product.GoodsId,
                      Num: product.Num, // check this
                      salesPrice: salesPrice,
                      UnitName: product.UnitName
                    });
                  } else {
                    purchaseOrderItemList[itemIndex].POIIds.push(product.POIId);
                  }
                }
              );

              data.POId = [...new Set(POId)];
              data.State = 1;
              data.supplierId = supplierId;
              data.BranchId = branchId;
              data.purchaseOrderItemList = purchaseOrderItemList;
              data.branchDetails = getBranchByBranchId.data.data;
              //data.businessDetails = getOneBusinessBy.data.data;
              data.supplierDetails = getSupplier.data.data;

              let id = JSON.stringify(data.POId);

              axios
                .all([
                  axios.get(
                    `${process.env.REACT_APP_API_URL}/api/getItemListInfo/`,
                    {
                      headers: {
                        Authorization: "Basic " + this.props.auth.token,
                      },
                      params: {
                        id: id,
                      },
                    }
                  ),
                  axios.get(
                    `${process.env.REACT_APP_API_URL}/api/getPurchaseOrderOperator/`,
                    {
                      headers: {
                        Authorization: "Basic " + this.props.auth.token,
                      },
                      params: {
                        id: id,
                      },
                    }
                  ),
                  axios.get(
                    `${process.env.REACT_APP_API_URL}/api/getPurchaseOrderRemark/`,
                    {
                      headers: {
                        Authorization: "Basic " + this.props.auth.token,
                      },
                      params: {
                        id: id,
                      },
                    }
                  ),
                ])
                .then(
                  axios.spread(
                    (
                      getItemListInfo,
                      getPurchaseOrderOperator,
                      getPurchaseOrderRemark
                    ) => {
                      if (
                        typeof getItemListInfo.data.data === "object" &&
                        typeof getPurchaseOrderOperator.data.data ===
                          "object" &&
                        typeof getPurchaseOrderRemark === "object"
                      ) {
                        data.getPurchaseOrdersItemsBySupplierId =
                          getPurchaseOrdersItemsBySupplierId.data.data;
                        data.poData =
                          getPurchaseOrdersItemsBySupplierId.data.poData;
                        data.OrderName =
                          getPurchaseOrdersItemsBySupplierId.data.poData[0].OrderName;
                        data.deliveryDate =
                          getPurchaseOrdersItemsBySupplierId.data.poData[0].StorageDate;
                        data.DepId =
                          getPurchaseOrdersItemsBySupplierId.data.poData[0].DepId;
                        data.DepName =
                          getPurchaseOrdersItemsBySupplierId.data.poData[0].DepName;

                        data.operatorDetails =
                          getPurchaseOrderOperator.data.data;
                        data.OperatorId = data.operatorDetails[0].OperatorId;
                        data.remarkDetails = getPurchaseOrderRemark.data.data;
                        //data.DepId = getDepartment.data.data[0].DepId;
                        data.StorageId = getStorage.data.data[0].StorageId;

                        this.setState(
                          {
                            data: data,
                            dataInfo: getItemListInfo.data.data,
                            dataDepartments: getDepartment.data.data,
                            dataStorage: getStorage.data.data,
                          },
                          () => {
                            let productInfo;
                            let poDataInfo = [];

                            data.purchaseOrderItemList.forEach((item) => {
                              // IS_PurchaseOrderItemInfo
                              productInfo = this.getProductUIInfo(
                                item.GoodsId,
                                item.GoodsFormatId
                              );

                              if (productInfo.length > 0) {
                                productInfo.forEach((row) => {
                                  let index = poDataInfo.findIndex(
                                    (obj) =>
                                      obj.GoodsId == item.GoodsId &&
                                      obj.GoodsFormatId == item.GoodsFormatId &&
                                      obj.DepId == row.DepId
                                  );
                                  if (index === -1) {
                                    poDataInfo.push({
                                      GoodsId: item.GoodsId,
                                      GoodsFormatId: item.GoodsFormatId,
                                      DepId: !this.props.auth.consolidation
                                        ? this.state.data.DepId
                                        : row.DepId,
                                      Num: row.Num,
                                      SalesPrice: item.salesPrice,
                                    });
                                  } else {
                                    poDataInfo[index].Num =
                                      poDataInfo[index].Num + row.Num;
                                  }
                                });
                              } else {
                                // no record found in IS_PurchaseOrderItemInfo
                                let index = poDataInfo.findIndex(
                                  (obj) =>
                                    obj.GoodsId == item.GoodsId &&
                                    obj.GoodsFormatId == item.GoodsFormatId &&
                                    obj.DepId == 0
                                );
                                if (index === -1) {
                                  let Num = 0;
                                  if (!this.props.auth.consolidation) {
                                    Num = this.getTemplateProductNum(
                                      item.GoodsId,
                                      item.GoodsFormatId
                                    );
                                  }
                                  poDataInfo.push({
                                    GoodsId: item.GoodsId,
                                    GoodsFormatId: item.GoodsFormatId,
                                    DepId: !this.props.auth.consolidation
                                      ? this.state.data.DepId
                                      : 0,
                                    Num: Num,
                                    SalesPrice: item.salesPrice,
                                  });
                                } else {
                                  if (productInfo.length) {
                                    poDataInfo[index].Num =
                                      poDataInfo[index].Num +
                                      productInfo[0].Num;
                                  }
                                }
                              }
                            });

                            // this is the main data object controlling unit/salesPrice!
                            this.props
                              .setPODataInfo({
                                mode: "replace",
                                supplierId: this.props.match.params.supplierId,
                                data: poDataInfo,
                              })
                              .then(() => {
                                this.setState(
                                  {
                                    isLoading: false,
                                  },
                                  async () =>  {
                                    // PO Item List QA
                                    let res = await this.getSupplierInventory();
                                    this.setState({
                                      dataProducts:res.data.data
                                    },  () => {
                                      this.purchaseOrderItemListQA();
                                    });
                                  }
                                );
                              });
                          }
                        );
                      } else {
                        this.handleErrorAPI();
                      }
                    }
                  )
                )
                .catch((err) => {
                  this.handleServerErrorAPI(err);
                });
            } else {
              this.handleErrorAPI();
            }
          }
        )
      )
      .catch((err) => {
        this.handleServerErrorAPI(err);
      });
  };

  handleDownloadPo = (po) => {
    this.setState(
      {
        isPrint: true,
      },
      () => {
        //let dataObj = this.getPoData();
        let html = utf8.encode(document.getElementById("root").innerHTML);

        this.setState(
          {
            isLoading: true,
            saveSuccessful: false,
            serverError: false,
            errorAPI: false,
          },
          () => {
            axios
              .request({
                responseType: "application/json",
                url: process.env.REACT_APP_API_URL_PDF,
                method: "get",
                params: {
                  html: html,
                },
                headers: {
                  Accept: "application/pdf",
                },
              })
              .then((response) => {
                (async () => {
                  //let base64 = await Buffer.from(response.data, 'base64');
                  const blob = dataURItoBlob(response.data);
                  this.setState(
                    {
                      isLoading: false,
                      isPrint: false,
                    },
                    () => {
                      FileSaver.saveAs(
                        new Blob([blob], { type: "application/pdf" }),
                        `${po}.pdf`
                      );
                    }
                  );
                })();
              })
              .catch((err) => {
                this.handleServerErrorAPI(err);
              });
          }
        );
      }
    );
  };
  
  handleEmailPoSend = (to, message, sendMe) => {
    console.log("im emailing..");

    if (sendMe) {
      to =
        to +
        "," +
        this.getSupplierEmail(this.getSupplierDetailsProperty("email"));
    }

    let dataObj = this.getPoData();

    axios
      .request({
        responseType: "arraybuffer",
        url: `${process.env.REACT_APP_API_URL}/api/pdfmake/po`,
        method: "post",
        data: {
          data: dataObj,
        },
        headers: {
          Accept: "application/pdf",
          Authorization: `Basic ${this.props.auth.token}`,
        },
      })
      .then((response) => {
        let base64String = uint8ToBase64(response.data);

        axios
          .request({
            url: `${process.env.REACT_APP_API_URL}/api/nodemailer`,
            method: "post",
            data: {
              orderName: this.state.data.OrderName,
              to: to,
              html: message,
              pdf: base64String,
            },
            headers: {
              Accept: "application/pdf",
              Authorization: `Basic ${this.props.auth.token}`,
            },
          })
          .then((response) => {
            this.handleCloseEmailModal();
          })
          .catch((error) => {
            console.error(error.response);
          });
      })
      .catch((err) => {
        this.handleServerErrorAPI(err);
      });
  };


/*
 Product Modal
*/

  handleOpenAddProductModal = () => {
    this.setState(
      {
        isLoading: true,
      }, () => {
      (async () => {
      let res = await this.getSupplierInventory();
        if (typeof res.data.data === "object") {
          this.setState({
            isLoading: false,
            addProductModalShow: true,
            dataProducts: res.data.data,
          });
        } else {
          this.handleErrorAPI();
        }
      })();
    })
  }

  handleCloseAddProductModal = () => {
    this.setState({
      addProductModalShow: false,
      addProductModalShowAttribute: false,
      productsAdd: [],
    });
  };

  handleAddProductNext = () => {
    this.setState({
      addProductModalShowAttribute: true,
    });
  };

  handleAddProductConfirm = () => {
    let data = [];
    let dataInfo = [];
    let dataPurchaseOrderItemList = [];
    let poDataInfo = [];

    this.setState(
      {
        isLoading: true,
      },
      () => {
        data = JSON.parse(JSON.stringify(this.state.data));
        dataInfo = JSON.parse(JSON.stringify(this.state.dataInfo));

        this.state.productsAdd.forEach((product) => {
          let POIId = new Date().valueOf();

          let purchaseOrderItemList = {
            GoodsCode: product.goodsCode,
            GoodsFormatId: product.goodsFormatId,
            GoodsFormatName: product.goodsFormatName,
            GoodsFormatNum: product.goodsFormatNum,
            GoodsId: product.goodsId,
            GoodsName: product.goodsName,
            Num: product.num,
            POIId: POIId,
            POIIds: [POIId],
            salesPrice: parseFloat(product.sellPrice),
            UnitName: product.unitName
          };

          // does this goodsId and goodsFormatId exist?
          let index = data.purchaseOrderItemList.findIndex(
            (row) =>
              row.GoodsId === product.goodsId &&
              row.GoodsFormatId === product.goodsFormatId
          );
          if (index === -1) {
            dataPurchaseOrderItemList.push(purchaseOrderItemList);
          } else {
            if (this.props.auth.consolidation) {
              data.purchaseOrderItemList[index].POIIds.push(POIId);
            } else {
              //data.purchaseOrderItemList[index].Num = parseFloat(data.purchaseOrderItemList[index].Num) + parseFloat(product.num);
            }
          }

          // state -> POIId, POId, Num, DepId, StorageId
          dataInfo.push({
            POIId: POIId,
            POId: 0,
            Num: parseFloat(product.num),
            DepId: parseInt(product.depId),
            StorageId: 0,
          });

          // redux
          poDataInfo.push({
            GoodsId: product.goodsId,
            GoodsFormatId: product.goodsFormatId,
            DepId:
              this.props.auth.consolidation === true
                ? parseInt(product.depId)
                : this.state.data.DepId,
            Num: parseFloat(product.num),
            SalesPrice: parseFloat(product.sellPrice),
            UnitName: product.unitName
          });
        });

        data.purchaseOrderItemList = data.purchaseOrderItemList.concat(
          dataPurchaseOrderItemList
        );

        this.props
          .setPODataInfo({
            mode: "concat",
            supplierId: this.props.match.params.supplierId,
            data: poDataInfo,
          })
          .then(() => {
            this.setState(
              {
                isLoading: false,
                data: data,
                dataInfo: dataInfo,
              },
              () => {
                this.handleCloseAddProductModal();
              }
            );
          });
      }
    );
  };

  handleAdvancedSearch = (mode) => {
    let property = "advancedSearch" + mode;
    this.setState({
      [property]: !this.state[property],
    });
  };

  htmlAddProductsList = () => {
    let html = this.state.dataProducts.map((row) => {
      //let index = -1;
      //if(!this.props.auth.consolidation) {
      //    index = this.state.data.purchaseOrderItemList.findIndex( (product) => product.GoodsId === row.GoodsId );
      //}
      //if(index === -1) {
      return row.goodsFormatList.map((goodFormat, index) =>
        this.filterProducts(row.GoodsCode, row.GoodsName, goodFormat, index)
      );
      //}
    });

    let isProducts =
      html.findIndex((product) => typeof product === "object") > -1;

    if (isProducts) {
      return (
        <Table responsive bordered hover>
          <thead>
            <tr>
              <th>
                <Basket
                  size={16}
                  className="mb-1 mr-1 d-none d-lg-inline d-xl-inline"
                />
                <I18N type="ui" path="PRODUCT_NAME" def="貨品名稱"/>
              </th>
              <th>
                <Box
                  size={16}
                  className="mb-1 mr-1 d-none d-lg-inline d-xl-inline"
                />
                <I18N type="ui" path="PRODUCT_PACKAGING_UNIT" def="單位"/>
              </th>
              <th>
                <Cash
                  size={16}
                  className="mb-1 mr-1 d-none d-lg-inline d-xl-inline"
                />
                <I18N type="ui" path="PRODUCT_UNIT_PRICE" def="單價"/>
              </th>
            </tr>
          </thead>
          <tbody>{html}</tbody>
        </Table>
      );
    } else {
      return (
        <ListGroup.Item className="text-info">
          <XCircle size={16} className="mb-1 mr-1" />
          <I18N type="ui" path="NO_PRODUCTS_FOUND" def="No products found"/>
        </ListGroup.Item>
      );
    }
  };

  filterProducts = (goodsCode, goodsName, item, index) => {
    let supplierMatch = getSearchTermMatch(
      `${goodsCode}${goodsName}`,
      this.state.productSearchTerms
    );
    if (supplierMatch) {
      let label = goodsCode 
      ? <>
        <>({goodsCode}) </>
        <I18N 
        type={PRODUCTS}
        value={item.GoodsId} 
        def={goodsName} />
        </> 
      : goodsName;

      let html = (
        <tr key={`${item.GoodsId}-${index}`}>
          <td width="60%">
            <Form.Check
              type="checkbox"
              label={label}
              id={`add-product-${item.GoodsId}-${index}`}
              checked={
                this.getAddProductIndex(item.GoodsId, item.GoodsFormatId) !== -1
                  ? true
                  : false
              }
              onChange={(e) =>
                this.handleClickSearchAddProduct(e, goodsName, goodsCode, item)
              }
            />
          </td>
          <td>
          {`${item.Num}/`}
          <I18N type={UNITS} value={item.GoodsFormatName} def={item.GoodsFormatName} />
          </td>
          <td>{formatCurrency(item.SellPrice)}</td>
        </tr>
      );
      return html;
    } else {
      return false;
    }
  };

  getAddProduct = (goodsId, goodsFormatId) => {
    return this.state.productsAdd.filter(
      (product) =>
        product.goodsId === goodsId && product.goodsFormatId === goodsFormatId
    )[0];
  };

  getAddProductIndex = (goodsId, goodsFormatId) => {
    return this.state.productsAdd.findIndex(
      (product) =>
        product.goodsId === goodsId && product.goodsFormatId === goodsFormatId
    );
  };

  handleClickSearchAddProduct = (e, goodsName, goodsCode, goodFormat) => {
    let arr = JSON.parse(JSON.stringify(this.state.productsAdd));
    let index = arr.findIndex(
      (item) =>
        item.goodsId === goodFormat.GoodsId &&
        item.goodsFormatId === goodFormat.GoodsFormatId
    );
    //schema, goodsId, goodsFormatId, num, depId, storageId
    if (e.currentTarget.checked) {
      // add
      if (index === -1) {
        arr.push({
          goodsName: goodsName,
          goodsCode: goodsCode,
          goodsId: goodFormat.GoodsId,
          goodsFormatId: goodFormat.GoodsFormatId,
          goodsFormatName: goodFormat.GoodsFormatName,
          goodsFormatNum: goodFormat.Num,
          num: 0,
          depId: 0,
          storageId: 0,
          sellPrice: goodFormat.SellPrice,
          unitName: goodFormat.UnitName
        });
      }
    } else {
      // remove
      if (index !== -1) {
        arr.splice(index, 1);
      }
    }

    this.setState({
      productsAdd: arr,
    });
  };

  handleChangeProductSearchTerms = (e) => {
    this.setState({
      productSearchTerms: e.currentTarget.value,
    });
  };

  handleChangeAddProductQuantity = (e, index) => {
    if (e.currentTarget.value >= 0) {
      let obj = JSON.parse(JSON.stringify(this.state.productsAdd));
      obj[index].num = e.currentTarget.value;
      this.setState({
        productsAdd: obj,
      });
    }
  };

  htmlAddProductAttributes = () => {
    return this.state.productsAdd.map((row, index) => {
      let poDataInfo = this.getPODataInfoByGoodsIdGoodsFormatId(
        row.goodsId,
        row.goodsFormatId
      );
      let htmlDropDownDepartmentOptions =
        this.htmlDropdownDepartmentOptions(poDataInfo);

      return (
        <div key={index} className="mt-2 mb-3 border-top">
          <div className="mt-2">
            <div>
              <span className="font-weight-bold text-secondary">
                {row.goodsName}
              </span>
            </div>
            <div>
              <span className="font-weight-light small">{`${
                row.goodsFormatNum
              }/${row.goodsFormatName} @ HKD ${formatCurrency(
                row.sellPrice
              )}`}</span>
            </div>
          </div>
          <Row>
            <Col md={12} lg={4} className="mt-2">
              {(!this.props.auth.consolidation &&
                this.isProductExist(row.goodsId)) ||
              (this.props.auth.consolidation &&
                htmlDropDownDepartmentOptions.every(
                  (element) => element === ""
                )) ? (
                <span className="small text-danger">
                  <I18N type="ui" path="PRODUCT_CANNOT_BE_ADDED" def="Product cannot be added"/>
                </span>
              ) : (
                <>
                  <Form.Label className="font-weight-bold"><I18N type="ui" path="PRODUCT_QUANTITY" def="數量"/></Form.Label>
                  <Form.Control
                    type="text"
                    id={`text-num-${row.goodsId}-${row.goodsFormatId}`}
                    value={row.num != "" ? toFixed(row.num, DECIMALS_5) : ""}
                    placeholder={0}
                    onChange={(e) =>
                      this.handleChangeAddProductQuantity(e, index)
                    }
                    size="sm"
                  />
                </>
              )}
            </Col>
            {this.props.auth.consolidation === true && (
              <Col md={12} lg={4} className="mt-2">
                {!htmlDropDownDepartmentOptions.every(
                  (element) => element === ""
                ) && (
                  <>
                    <Form.Label className="font-weight-bold">
                      Select Department<span className="text-danger">*</span>
                    </Form.Label>
                    <DropdownButton
                      id={`dropdown-department-${row.goodsId}-${index}`}
                      variant="secondary"
                      title={this.getDropdownDepartmentTitle(row.depId)}
                      size="sm"
                      onSelect={(value) =>
                        this.handleOnSelectDepartment(
                          value,
                          row.goodsId,
                          row.goodsFormatId
                        )
                      }
                    >
                      {htmlDropDownDepartmentOptions}
                    </DropdownButton>
                  </>
                )}
              </Col>
            )}
            {/*
                        <Col md={12} lg={4} className="mt-2">
                            <Form.Label className="font-weight-bold">
                                Select Storage
                            </Form.Label>
                            <DropdownButton
                                id={`dropdown-storage-${row.goodsId}-${index}`}
                                variant="secondary"
                                title={this.getDropdownStorageTitle(row.storageId)}
                                size="sm"
                                onSelect={(value) => this.handleOnSelectStorage(value, row.goodsId, row.goodsFormatId)}
                            >
                                {this.htmlDropdownStorageOptions(poDataInfo)}
                            </DropdownButton>
                        </Col>*/}
          </Row>
        </div>
      );
    });
  };

/*
  Department
*/

  getDropdownDepartmentTitle = (depId) => {
    if (depId) {
      let obj = this.getDepartmentInfo(depId);
      if (obj) {
        return obj.DepName;
      }
    } else {
      return "Select Department";
    }
  };

  getDepartmentInfo = (depId) => {
    return this.state.dataDepartments.filter(
      (dep) => dep.DepId === parseInt(depId)
    )[0];
  };

  htmlDropdownDepartmentOptions = (productInfo) => {
    let arry = [];
    let html = this.getProductInfoDepartments().map((row, index) => {
      if (row.DepId) {
        let skip = false;

        if (productInfo.length) {
          let prodIndex = productInfo.findIndex(
            (product) => product.DepId === row.DepId
          );
          if (prodIndex !== -1) {
            skip = true;
          }
        }

        if (arry.indexOf(row.DepId) === -1 && !skip) {
          arry.push(row.DepId);
          return (
            <Dropdown.Item as="button" key={index} eventKey={row.DepId}>
              {row.DepName}
            </Dropdown.Item>
          );
        } else {
          return "";
        }
      } else {
        return "";
      }
    });

    return html;
  };

  handleOnSelectDepartment = (value, goodsId, goodsFormatId) => {
    this.setProductsAddProperty(goodsId, goodsFormatId, "depId", value);
  };

  getDropdownStorageTitle = (storageId) => {
    if (storageId) {
      return this.state.dataStorage.filter(
        (storage) => storage.StorageId === parseInt(storageId)
      )[0].StorageName;
    } else {
      return "Select Storage";
    }
  };

/*
  Storage
*/

  htmlDropdownStorageOptions = (POIId, productInfo) => {
    let arry = [];
    let html = this.state.dataStorage.map((row, index) => {
      let skip = false;
      if (productInfo) {
        // check if department and storage is taken
        let prodIndex = productInfo.findIndex(
          (product) =>
            product.DepId === row.DepId && product.StorageId === row.StorageId
        );
        if (POIId && prodIndex !== -1) {
          skip = true;
        }
      }

      if (arry.indexOf(row.StorageId) === -1 && !skip) {
        arry.push(row.StorageId);
        return (
          <Dropdown.Item as="button" key={index} eventKey={row.StorageId}>
            {row.StorageName}
          </Dropdown.Item>
        );
      } else return ";"
    });
    return html;
  };

  handleOnSelectStorage = (value, goodsId, goodsFormatId) => {
    this.setProductsAddProperty(goodsId, goodsFormatId, "storageId", value);
  };

  setProductsAddProperty = (goodsId, goodsFormatId, property, value) => {
    let productsAdd = JSON.parse(JSON.stringify(this.state.productsAdd));
    let index = productsAdd.findIndex(
      (product) =>
        product.goodsId === goodsId && product.goodsFormatId === goodsFormatId
    );
    productsAdd[index][property] = value;
    this.setState({
      productsAdd: productsAdd,
    });
  };

  htmlAddProduct = () => {
    return (
      <Modal
        show={this.state.addProductModalShow}
        onHide={this.handleCloseAddProductModal}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title><I18N type="ui" path="ADD_PRODUCT" def="Add Product"/></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!this.state.dataProducts ? (
            <LoadingComponent />
          ) : (
            !this.state.addProductModalShowAttribute && (
              <>
                <Form.Group controlId="formProductSearchText">
                  <Form.Label className="font-weight-bold text-primary">
                  <I18N type="ui" path="FILTER_PRODUCT" def="Filter Product"/>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={this.state.i18n["PRODUCT_NAME"]}
                    value={this.state.productSearchTerms}
                    onChange={this.handleChangeProductSearchTerms}
                  />
                </Form.Group>
                <Form>
                  <ListGroup
                    className="mt-4"
                    style={{ maxHeight: 800, overflowY: "auto" }}
                  >
                    {this.htmlAddProductsList()}
                  </ListGroup>
                </Form>
              </>
            )
          )}

          {this.state.addProductModalShowAttribute && (
            <>
              <div className="float-right">
                <Button
                  variant="link"
                  className="px-0"
                  onClick={this.handleAddProductAttributesGoBack}
                >
                  <ArrowLeftCircle size={16} className="mb-1 mr-1" /> <I18N type="ui" path="GO_BACK" def="Go Back"/>
                </Button>
              </div>
              <div className="mt-4">
                <span className="font-weight-bold text-primary">
                  <I18N type="ui" path="PRODUCT_ATTRIBUTES" def="Product Attributes"/>
                </span>
              </div>
              <div className="mt-2">{this.htmlAddProductAttributes()}</div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleCloseAddProductModal}>
            <I18N type="ui" path="CLOSE" def="Close"/>
          </Button>
          {!this.state.addProductModalShowAttribute ? (
            <Button
              variant="primary"
              onClick={this.handleAddProductNext}
              disabled={this.state.productsAdd.length === 0 ? true : false}
            >
              <I18N type="ui" path="NEXT" def="Next"/>
            </Button>
          ) : (
            <Button
              variant="primary"
              disabled={this.isAddProductConfirmDisabled()}
              onClick={this.handleAddProductConfirm}
            >
              <I18N type="ui" path="CONFIRM" def="Confirm"/>
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  };

  isAddProductConfirmDisabled = () => {
    let disabled = false;
    if (this.props.auth.consolidation) {
      this.state.productsAdd.forEach((row) => {
        let poDataInfo = this.getPODataInfoByGoodsIdGoodsFormatId(
          row.goodsId,
          row.goodsFormatId
        );
        let htmlDropDownDepartmentOptions =
          this.htmlDropdownDepartmentOptions(poDataInfo);
        if (
          !htmlDropDownDepartmentOptions.every((element) => element === "") &&
          !row.depId
        ) {
          disabled = true;
        }
      });
    } else {
      disabled = true;
      this.state.productsAdd.forEach((row) => {
        if (!this.isProductExist(row.goodsId)) {
          disabled = false;
        }
      });
    }
    return disabled;
  };

  handleAddProductAttributesGoBack = () => {
    this.setState({
      addProductModalShowAttribute: false,
    });
  };

  handleChangePurchaseOrderItemListSalesPrice = (
    value,
    GoodsId,
    GoodsFormatId,
    DepId
  ) => {
    let salesPrice = value;

    if (salesPrice >= 0) {
      //if(this.props.auth.consolidation) {
      this.handleChangeProducInfoProp(
        "SalesPrice",
        null,
        GoodsId,
        GoodsFormatId,
        DepId,
        value
      );
      //} else {
      //    let data = JSON.parse(JSON.stringify(this.state.data));
      //    let index = data.purchaseOrderItemList.findIndex( (row) => row.GoodsId === GoodsId && row.GoodsFormatId === GoodsFormatId );
      //    if(index > -1) {
      //        data.purchaseOrderItemList[index].salesPrice = salesPrice;
      //        this.setState({
      //            data:data
      //        });
      //    }
      //}
    }
  };

  isProductExist = (goodsId, goodsFormatId) => {
    let index;
    if (goodsId && goodsFormatId) {
      index = this.state.data.purchaseOrderItemList.findIndex(
        (item) =>
          item.GoodsId === goodsId && item.GoodsFormatId === goodsFormatId
      );
    }
    if (goodsId) {
      index = this.state.data.purchaseOrderItemList.findIndex(
        (item) => item.GoodsId === goodsId
      );
    }
    if (index > -1) {
      return true;
    }
    return false;
  };

  getProductPOIId = (goodsId, goodsFormatId) => {
    let index = this.state.data.purchaseOrderItemList.findIndex(
      (item) => item.GoodsId === goodsId && item.GoodsFormatId === goodsFormatId
    );
    if (index > -1) {
      return this.state.data.purchaseOrderItemList[index].POIId;
    }
  };

  /*
    getProductInfo = (poiid) => {
        if(this.state.dataInfo) {
            let dataInfo = this.state.dataInfo.filter( (item) => item.POIId === poiid );
            return dataInfo;
        }
    }
    */

  getProductUIInfo = (GoodsId, GoodsFormatId) => {
    let purchaseOrderItemList = this.state.data.purchaseOrderItemList.filter(
      (item) => item.GoodsId === GoodsId && item.GoodsFormatId === GoodsFormatId
    )[0];
    let dataInfo = this.state.dataInfo.filter(
      (info) => purchaseOrderItemList.POIIds.indexOf(info.POIId) > -1
    );
    return dataInfo;
    /*
        if(this.state.dataInfo) {
            let dataInfo = this.state.dataInfo.filter( (item) => item.GoodsId === GoodsId && item.GoodsFormatId === GoodsFormatId );
            return dataInfo;
        }
        */
  };

  getProductInfoByPOIId = (POIId) => {
    if (this.state.dataInfo) {
      let dataInfo = this.state.dataInfo.filter((data) => data.POIId === POIId);
      if (dataInfo.length) {
        return dataInfo;
      }
      return [];
    }
    return [];
  };

  getProductInfoDepartments = () => {
    let arr = [];
    let index = this.getPODataInfoIndex();
    if (index > -1) {
      if (this.props.pendingDataPOInfo && this.state.dataDepartments) {
        this.props.pendingDataPOInfo[index].data.forEach((obj) => {
          if (
            arr.findIndex((item) => item.DepId == obj.DepId) === -1 &&
            obj.DepId > 0
          ) {
            let departmentInfo = this.getDepartmentInfo(obj.DepId);
            if (departmentInfo.DepName) {
              arr.push({
                DepId: obj.DepId,
                DepName: departmentInfo.DepName,
              });
            }
          }
        });
        arr.push({
          DepId: 0,
          DepName: this.state.data.branchDetails.BranchName,
        });
      }
    }

    return arr;
  };

  handleChangeProducInfoProp = (
    prop,
    e,
    GoodsId,
    GoodsFormatId,
    DepId,
    Value
  ) => {
    let value;
    if (e) {
      value = e.currentTarget.value;
    } else {
      value = Value;
    }

    if (value >= 0 || !value) {
      this.props
        .setPODataInfoProperty({
          supplierId: this.props.match.params.supplierId,
          prop: prop,
          GoodsId: GoodsId,
          GoodsFormatId: GoodsFormatId,
          DepId: DepId,
          value: value,
        })
        .then(() => {
          // get the total using GoodsId and GoodsFormatId
          //if(!this.props.auth.consolidation) {
          //    this.syncProductNum(false);
          //}
        });
    }
  };

  syncProductNum = (onLoad) => {
    console.log("SYNC PRODUCT NUM");

    let data = JSON.parse(JSON.stringify(this.state.data));
    data.purchaseOrderItemList.forEach((row) => {
      let total = 0;
      let poDataInfo = this.getPODataInfoByGoodsIdGoodsFormatId(
        row.GoodsId,
        row.GoodsFormatId
      );

      poDataInfo.forEach((data) => {
        total = parseFloat(total) + parseFloat(data.Num);
      });

      let index = data.purchaseOrderItemList.findIndex(
        (product) =>
          product.GoodsId === row.GoodsId &&
          product.GoodsFormatId === row.GoodsFormatId
      );

      if (index > -1) {
        if ((onLoad && total) || !onLoad) {
          data.purchaseOrderItemList[index].Num = total;
        }
      }
    });

    this.setState({
      data: data,
    });
  };

  getPODataInfoIndex = () => {
    return this.props.pendingDataPOInfo.findIndex(
      (obj) => obj.supplierId === this.props.match.params.supplierId
    );
  };

  getPODataInfoProperty = (prop, GoodsId, GoodsFormatId, DepId) => {
    let index = this.getPODataInfoIndex();
    if (index > -1) {
      let data = this.props.pendingDataPOInfo[index].data.filter(
        (product) =>
          product.GoodsId === GoodsId &&
          product.GoodsFormatId === GoodsFormatId &&
          product.DepId === DepId
      )[0];
      if (data) {
        return data[prop];
      }
    }
  };

  getPODataInfoByGoodsIdGoodsFormatId = (GoodsId, GoodsFormatId, DepId) => {
    let index = this.getPODataInfoIndex();
    if (index > -1) {
      if (this.props.auth.consolidation && DepId) {
        return this.props.pendingDataPOInfo[index].data.filter(
          (product) =>
            product.GoodsId === GoodsId &&
            product.GoodsFormatId === GoodsFormatId &&
            product.DepId === DepId
        );
      } else {
        return this.props.pendingDataPOInfo[index].data.filter(
          (product) =>
            product.GoodsId === GoodsId &&
            product.GoodsFormatId === GoodsFormatId
        );
      }
    }
  };

  getTemplateProductNum = (GoodsId, GoodsFormatId) => {
    let num = 0;
    let arr = this.state.data.getPurchaseOrdersItemsBySupplierId.filter(
      (product) =>
        product.GoodsId === GoodsId && product.GoodsFormatId === GoodsFormatId
    );
    if (arr.length) {
      let num = 0;
      arr.forEach((row) => (num = num + row.Num));
      return num;
    }
    return num;
  };

  htmlProductDepartmentNum = (item, DepId) => {
    let data = [];
    let productInfo = [];

    // this.props.pendingDataPOInfo
    productInfo = this.getPODataInfoByGoodsIdGoodsFormatId(
      item.GoodsId,
      item.GoodsFormatId,
      DepId
    );

    if (productInfo.length > 0) {
      productInfo.forEach((row) => {
        let index = data.findIndex((obj) => obj.DepId === row.DepId);
        let Num = this.getPODataInfoProperty(
          "Num",
          item.GoodsId,
          item.GoodsFormatId,
          row.DepId
        );

        /*
                if(!this.props.auth.consolidation && !Num) {
                    Num = this.getTemplateProductNum(item.GoodsId, item.GoodsFormatId);
                }
                */

        if (index === -1) {
          data.push({
            GoodsId: item.GoodsId,
            GoodsFormatId: item.GoodsFormatId,
            DepId: row.DepId,
            Num: Num,
          });
        } else {
          data[index].Num = data[index].Num + Num;
        }
      });
    }

    let total = 0.0;
    let html = data.map((product, index) => {
      if (product.Num) {
        total = parseFloat(total) + parseFloat(product.Num);
      }

      return (
        <>
          <div key={index} className={index > 0 ? "mt-2" : ""}>
            {/*product.DepId
                    ?
                        <span className="font-weight-bold text-secondary">{this.getDropdownDepartmentTitle(product.DepId)}</span>
                    : 
                    <></>
                    */}
            <Form.Control
              type="text"
              id={`text-num-${DepId}-${item.GoodsId}`}
              value={product.Num != "" ? toFixed(product.Num, DECIMALS_5) : ""}
              placeholder={0}
              onChange={(value) =>
                this.handleChangeProducInfoProp(
                  "Num",
                  value,
                  item.GoodsId,
                  item.GoodsFormatId,
                  product.DepId
                )
              }
              size="sm"
              disabled={this.isDisabledNum(item.GoodsId)}
            />
          </div>
        </>
      );
    });

    return (
      <>
        {html}
        {data.length > 1 && (
          <div className="mt-2 text-right">
            <span className="font-weight-bold text-secondary small">
              Total: {formatCurrency(total)}
            </span>
          </div>
        )}
      </>
    );
  };

// (Boolean) Is Disabled Product Quantity
  isDisabledNum = (goodsId) => {
    // disabled if inactive, check warnings
    let filter = this.state.warnings.inactive.filter( (obj) => obj.goodsId === goodsId )[0];
    if(filter) {
      return true;
    }
    return false;
  }

  htmlPurchaseOrderTable = () => {
    let html = this.getProductInfoDepartments().map((department, index) => {
      // does this department have any products?
      let i = this.getPODataInfoIndex();
      if (i > -1) {
        if (
          this.props.pendingDataPOInfo[i].data.findIndex(
            (product) => product.DepId === department.DepId
          ) > -1
          ) {
          return (
            <div className={index > 0 ? "mt-4" : ""} key={index}>
              <h5 className="text-primary">
                <I18N 
                type={DEPARTMENTS} 
                value={{
                  "businessId":this.props.auth.businessId,
                  "branchId":this.state.data.branchDetails.BranchId,
                  "depId":department.DepId
                }} 
                property="DepName" 
                def={department.DepName}
                />
              </h5>
              <Table borderless hover className="table-po">
                <thead className="bg-primary text-white">
                  <tr>
                    <th></th>
                    <th><I18N type="ui" path="PRODUCT_CODE" def="貨品編號"/></th>
                    <th>
                      {/* {!this.isReadOnly() && (
                        <Basket
                          size={16}
                          className="mb-1 mr-1 d-none d-lg-inline d-xl-inline"
                        />
                      )} */}
                      <I18N type="ui" path="PRODUCT_NAME" def="貨品名稱"/>
                    </th>
                    <th>
                      {/* {!this.isReadOnly() && (
                        <Calculator
                          size={16}
                          className="mb-1 mr-1 d-none d-lg-inline d-xl-inline"
                        />
                      )} */}
                      <I18N type="ui" path="PRODUCT_QUANTITY" def="數量"/>
                    </th>
                    <th>
                      {/* {!this.isReadOnly() && (
                        <Box
                          size={16}
                          className="mb-1 mr-1 d-none d-lg-inline d-xl-inline"
                        />
                      )} */}
                      <I18N type="ui" path="PRODUCT_PACKAGING_UNIT" def="包裝單位"/>
                    </th>
                    <th>
                      {/* {!this.isReadOnly() && (
                        <Cash
                          size={16}
                          className="mb-1 mr-1 d-none d-lg-inline d-xl-inline"
                        />
                      )} */}
                      <I18N type="ui" path="PRODUCT_UNIT_PRICE" def="單價"/>
                    </th>
                    <th className="text-right">
                      {/* {!this.isReadOnly() && (
                        <CashStack
                          size={16}
                          className="mb-1 mr-1 d-none d-lg-inline d-xl-inline"
                        />
                      )} */}
                      <I18N type="ui" path="TOTAL" def="合計"/>
                    </th>
                  </tr>
                </thead>
                {this.htmlPurchaseOrderItemList(department.DepId)}
              </Table>
            </div>
          );
        } else return "";
      } else return "";
    });
    return html;
  };

  htmlPurchaseOrderItemList = (DepId) => {
    let purchaseOrderItemList = JSON.parse(
      JSON.stringify(this.state.data.purchaseOrderItemList)
    );
    let poItemList;

    if (DepId > 0) {
      let dataInfo = this.state.dataInfo.filter(
        (dataInfo) => dataInfo.DepId === DepId
      );
      poItemList = purchaseOrderItemList.filter((item) => {
        let match = false;
        item.POIIds.forEach((POIId) => {
          if (dataInfo.findIndex((data) => data.POIId === POIId) > -1) {
            match = true;
          }
        });
        return match;
      });
    } else {
      poItemList = purchaseOrderItemList.filter((item) => {
        let match = true;
        item.POIIds.forEach((POIId) => {
          if (match) {
            if (
              this.state.dataInfo.findIndex((data) => data.POIId === POIId) > -1
            ) {
              match = false;
            }
          }
        });
        return match;
      });
    }

    let itemList = [];
    if (this.props.auth.consolidation) {
      //itemList = purchaseOrderItemList;
      itemList = poItemList;
    } else {
      itemList = purchaseOrderItemList;
    }

    let html = itemList.map((item, index) => {

      return (
        <tr key={index}>
          <td>
            {this.isWarningItem(item.GoodsId) &&
              <ExclamationTriangleFill
              size={16} 
              className="mb-1 mr-1 text-warning" 
              />
            }    
          </td>
          <td>{item.GoodsCode}</td>
          <td>
            <I18N
              type={PRODUCTS}
              value={item.GoodsId}
              def={item.GoodsName}
            />
          </td>
          <td>
            {!this.isReadOnly()
              ? this.htmlProductDepartmentNum(item, DepId)
              : item.Num}
          </td>
          <td>
            {packagingUnitLabel(
                1, // temporarily code isShowPrice true
                item.GoodsFormatNum,
                item.GoodsFormatName,
                item.UnitName,
                item.SellPrice
            )}
          </td>
          <td>
            {!this.isReadOnly() ? (
              <Form.Control
                type="text"
                id={`text-salesPrice-${DepId}-${item.GoodsId}`}
                data-goodsid={item.GoodsId}
                value={this.getSalesPrice(
                  item.GoodsId,
                  item.GoodsFormatId,
                  DepId
                )}
                placeholder={0}
                onChange={(e) =>
                  this.handleChangePurchaseOrderItemListSalesPrice(
                    e.currentTarget.value,
                    item.GoodsId,
                    item.GoodsFormatId,
                    DepId
                  )
                }
                size="sm"
              />
            ) : (
              this.getSalesPrice(item.GoodsId, item.GoodsFormatId, DepId)
            )}
          </td>
          <td className="text-right">
            {formatCurrency(
              this.getProductNum(item.GoodsId, item.GoodsFormatId, DepId) *
                this.getSalesPrice(item.GoodsId, item.GoodsFormatId, DepId)
            )}
          </td>
        </tr>
      );
    });

    return <tbody>{html}</tbody>;
  };

// (Boolean) Is Warning Item

  isWarningItem = (goodsId) => {
    let index = this.state.warnings.sellPrice.findIndex( (item) => item.goodsId === goodsId);
    if(index > -1) {
      return true;
    }

    index = this.state.warnings.inactive.findIndex( (item) => item.goodsId === goodsId);
    if(index > -1) {
      return true;
    }
    return false;
  }

// QA the PO items (price, state)
  purchaseOrderItemListQA = () => {
    let warnings = JSON.parse(JSON.stringify(this.state.warnings));

    //this.getProductInfoDepartments().map((department, index)
    let productInfoDepartments = this.getProductInfoDepartments().filter( (department) => department.DepId > 0 );

    productInfoDepartments.forEach( (department) => {
      let index = this.getPODataInfoIndex();
      if (index > -1) {

        this.state.data.purchaseOrderItemList.forEach( (item) => {
          
            let backendItem = this.getSupplierInventoryItem(item.GoodsId, item.GoodsFormatId);
  
            if(backendItem && backendItem.SellPrice !== item.salesPrice) {
              // warning
              warnings.sellPrice.push({
                goodsId:item.GoodsId,
                goodsFormatId:item.GoodsFormatId,
                goodsName:item.GoodsName,
                salesPrice:item.salesPrice
              });

              // update salesPrice textbox
              this.handleChangePurchaseOrderItemListSalesPrice(
                backendItem.SellPrice,
                item.GoodsId,
                item.GoodsFormatId,
                department.DepId
              );
            }

            if(!backendItem) {
              let index = warnings.inactive.findIndex( (obj) => obj.goodsId === item.GoodsId );
              // only add single instance of inactive product
              if(index === -1) {
                warnings.inactive.push({
                  goodsId:item.GoodsId,
                  goodsFormatId:item.GoodsFormatId,
                  goodsName:item.GoodsName,
                  salesPrice:item.salesPrice
                });
  
                // update qty textbox
                this.handleChangeProducInfoProp(
                  "Num",
                  0,
                  item.GoodsId,
                  item.GoodsFormatId,
                  department.DepId
                )
              }

            }
         
          this.setState({
            warnings:warnings
          });
        });
      }
    });
  }

  getSupplierInventoryItem = (goodsId, goodsFormatId) => {
    let product = this.state.dataProducts.filter( (item) => item.GoodsId === goodsId)[0];
    
    if(product) {
      let goodsFormatItem = product.goodsFormatList.filter( (goodsFormat) => goodsFormat.GoodsFormatId === goodsFormatId )[0];
      if(goodsFormatItem) {
        return goodsFormatItem;
      }
    }
    return;
  }

  getProductNum = (GoodsId, GoodsFormatId, DepId) => {
    return this.getPODataInfoProperty("Num", GoodsId, GoodsFormatId, DepId);
  };

  getSalesPrice = (GoodsId, GoodsFormatId, DepId) => {
    let salesPrice = this.getPODataInfoProperty(
      "SalesPrice",
      GoodsId,
      GoodsFormatId,
      DepId
    );
    return salesPrice != "" ? toFixed(salesPrice, DECIMALS_10) : "";
  };

  htmlSubTotal = () => {
    let tally = 0;

    let index = this.getPODataInfoIndex();
    if (index > -1) {
      this.props.pendingDataPOInfo[index].data.forEach((item) => {
        tally = tally + (!item.Num ? 0 : item.Num) * item.SalesPrice;
      });
    }

    return tally;
  };

  htmlTotal = () => {
    return this.htmlSubTotal();
  };

  handleCloseEmailModal = () => {
    this.setState({
      emailModalShow: false,
      emailModalProcessing: false,
    });
  };

  handleOpenEmailModal = () => {
    this.setState({
      emailModalShow: true,
    });
  };

  handleEmailSubmit = (values) => {
    this.setState(
      {
        emailModalProcessing: true,
      },
      () => {
        this.handleEmailPoSend(
          values.emailTo,
          values.emailMessage,
          values.emailSendMe
        );
      }
    );
  };

  getSupplierEmail = (email) => {
    if (email) return email.split(",")[0];
  };

  htmlEmail = () => {
    return (
      <Formik
        validationSchema={validationSchema}
        initialValues={{ emailTo: "", emailMessage: "", emailSendMe: false }}
        onSubmit={(values) => this.handleEmailSubmit(values)}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <Modal
            show={this.state.emailModalShow}
            onHide={this.handleCloseEmailModal}
          >
            <Modal.Header closeButton>
              <Modal.Title>Purchase Order - Email</Modal.Title>
            </Modal.Header>
            <Form noValidate onSubmit={handleSubmit}>
              <Modal.Body>
                {this.state.emailModalProcessing ? (
                  <LoadingComponent />
                ) : (
                  <>
                    <Form.Group controlId="formEmailTo">
                      <Form.Label>To</Form.Label>
                      <Form.Control
                        type="textbox"
                        name="emailTo"
                        placeholder="Enter to email address"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.emailTo}
                        isInvalid={touched.emailTo && errors.emailTo}
                        className={touched.v && errors.emailTo ? "error" : null}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.emailTo}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId="formEmailSendMe">
                      <Form.Check
                        type={"checkbox"}
                        id="emailSendMe"
                        label={
                          "Include me (" +
                          this.getSupplierEmail(
                            this.getSupplierDetailsProperty("email")
                          ) +
                          ")"
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.emailMessage}
                      />
                    </Form.Group>

                    <Form.Group controlId="formEmailMessage">
                      <Form.Label>Message</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="emailMessage"
                        placeholder=""
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.emailMessage}
                        isInvalid={touched.emailMessage && errors.emailMessage}
                        className={
                          touched.emailMessage && errors.emailMessage
                            ? "error"
                            : null
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.emailMessage}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={this.handleCloseEmailModal}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={this.state.emailModalProcessing}
                >
                  Send
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>
        )}
      </Formik>
    );
  };

  handleClickSavePurchaseOrder = () => {
    this.setState({
      showAlertModal: true,
      alertModalConfig: {
        title:(<><I18N type="ui" path="PURCHASE_ORDER" def="Purchase Order"/> - <I18N type="ui" path="SAVE" def="Save"/></>),
        warning:(<><I18N type="ui" path="SAVE_PURCHASE_ORDER" def="Save Purchase Order"/><>?</></>),
        function: this.handleSaveConfirm,
      },
    });
  };

  handleToggleAlertModal = () => {
    this.setState({
      showAlertModal: !this.state.showAlertModal,
    });
  };

  handleSaveConfirm = (callback) => {
    // to-do
  };

  htmlAlertModal = () => {
    return (
      <Modal
        show={this.state.showAlertModal}
        onHide={this.handleToggleAlertModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>{this.state.alertModalConfig.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mt-4 text-center">
            <ExclamationCircle size={64} className="mb-1 mr-1 text-warning" />
            <div>{this.state.alertModalConfig.warning}</div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleToggleAlertModal}>
            <I18N type="ui" path="CANCEL" def="Cancel"/>
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              this.setState(
                {
                  showAlertModal: false,
                },
                () => {
                  this.state.alertModalConfig.function();
                }
              );
            }}
          >
            <I18N type="ui" path="CONFIRM" def="Confirm"/>
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  handleToggleUndoModal = () => {
    this.setState({
      showUndoModal: !this.state.showUndoModal,
    });
  };

  handleUndoChanges = () => {
    this.handleToggleUndoModal();
  };

  handleUndoChangesConfirm = () => {
    // to-do
  };

  htmlUndoChanges = () => {
    return (
      <Modal
        show={this.state.showUndoModal}
        onHide={this.handleToggleUndoModal}
      >
        <Modal.Header closeButton>
        <Modal.Title><><I18N type="ui" path="PURCHASE_ORDER" def="Purchase Order"/> - <I18N type="ui" path="UNDO_CHANGES" def="Undo Changes"/></></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mt-4 text-center">
            <ExclamationCircle size={64} className="mb-1 mr-1 text-warning" />
            <div><I18N type="ui" path="REVERT_PURCHASE_ORDER" def="Revert Purchase Order"/>?</div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleToggleUndoModal}>
            <I18N type="ui" path="CANCEL" def="Cancel"/>
          </Button>
          <Button variant="primary" onClick={this.handleUndoChangesConfirm}>
            <I18N type="ui" path="CONFIRM" def="Confirm"/>
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  handleClickConfirmPurchaseOrder = () => {
    /*
       axios.get(`${process.env.REACT_APP_API_URL_PO_LOGGING}`, 
       {
           params:{
            logType:'po',
            id:2345
           },
           headers: {
             'Authorization': `Basic ${this.props.auth.token}`,
           }
       })
       .then( (response) => {
           console.log(response);
       })
       .catch( (error) => {
           this.setState({
               apiErrorMessage: 'Bad Request (500)',
               isLoading: false
           });
       });  
       */

    this.setState({
      showAlertModal: true,
      alertModalConfig: {
        title:(<><I18N type="ui" path="PURCHASE_ORDER" def="Purchase Order"/><> - </><I18N type="ui" path="CONFIRM" def="Confirm"/></>),
        warning:(<><I18N type="ui" path="CONFIRM_PURCHASE_ORDER" def="Confirm Purchase Order"/><>?</></>),
        function: () => this.handleConfirmPO(),
      },
    });
  };

  handleConfirmPO = () => {

    this.setState({
        isLoading:true,
        saveSuccessful:false,
        serverError:false,
        errorAPI:false,
    }, () => {

        axios.get(`${process.env.REACT_APP_API_URL}/api/getSessionKey/${this.state.data.OperatorId}`, {
            headers: {
                "Authorization": 'Basic ' + this.props.auth.token, //the token is a variable which holds the token      
            }
        })
        .then( (response) => {

            let sessionKey = response.data.data[0].sessionKey;

            if(sessionKey) {

                let depNum = 0;
                let orderNames = [];

                let productInfoDepartments = this.getProductInfoDepartments().filter( (department) => department.DepId > 0 );

                productInfoDepartments.forEach( (department) => {
                   
                        // success
                        let goodsList = [];
                        let goodsListReceipt = [];            
                        let pendingDataPOInfo = [];                
                        let index = this.getPODataInfoIndex();

                        if(index > -1) {
                            pendingDataPOInfo = this.props.pendingDataPOInfo[index].data.filter( (row) => row.DepId === department.DepId );
                        }
                        
                        pendingDataPOInfo.forEach((product) => {
                            let num = parseFloat(product.Num).toFixed(DECIMALS_5);
                            let salesPrice = parseFloat(product.SalesPrice).toFixed(DECIMALS_10);
                            if(num > 0) {
                                goodsList.push({
                                    goodsId:product.GoodsId,
                                    num:parseFloat(num),
                                    goodsFormatId:product.GoodsFormatId,
                                    sortVal:0,
                                    salesPrice:parseFloat(salesPrice)
                                });
    
                                goodsListReceipt.push({
                                    goodsId: product.GoodsId,
                                    goodsFormatId: product.GoodsFormatId,
                                    storageNum:parseFloat(num),
                                    isExtra: 0,
                                    state: 2,
                                    price:parseFloat(salesPrice)         
                                });
                            }
                        });
        
                        let params = {
                            depId:department.DepId,
                            storageId:this.state.data.StorageId,
                            storageDate:`${moment(this.state.data.deliveryDate).format("YYYY-MM-DD")} 00:00:00`,
                            remark:this.getSanitizeRemark(),
                            supplierId:parseInt(this.props.match.params.supplierId),
                            goodsList:goodsList      
                        };

                        (async () => {
                            await axios.post(process.env.REACT_APP_API_URL_ORDER, {
                                query: `
                                    mutation foo($depId:Int!, $storageId:Int!, $storageDate:String!, $remark:String!, $state:Int!, $supplierId:Int!, $goodsList:[goodsListInput]) {
                                        createOrder(depId:$depId, storageId:$storageId, storageDate:$storageDate, remark:$remark, state:$state, supplierId:$supplierId, goodsList:$goodsList) { 
                                            responseCode
                                            responseMsg
                                            data {
                                                orderName
                                            }
                                        }
                                    }
                                `,
                                variables: {
                                  depId:params.depId,
                                  storageId:params.storageId,
                                  storageDate:params.storageDate,
                                  remark:params.remark,
                                  state:2,
                                  supplierId:params.supplierId,
                                  goodsList:params.goodsList
                                },
                              },{
                                headers: {
                                    branchid:this.state.data.BranchId,
                                    sessionkey:sessionKey,
                                    'Content-Type': 'application/json'
                                }
                            })
                            .then( (res) => {
                                let orderName = res.data.data.createOrder.data.orderName;

                                orderNames.push(orderName);

                                if(orderName) {
                                    (async () => {
                                        await axios.get(`${process.env.REACT_APP_API_URL_MODEL}/api/getPOItems`, {
                                            params: {
                                                orderName:orderName,
                                                depId:params.depId
                                            },
                                            headers: {
                                                operatorid:this.state.data.OperatorId,
                                                branchid:this.state.data.BranchId,
                                                sessionkey:sessionKey
                                            }
                                        }).then((result) => {
                                            // get the purchase order id (POId)
                                            // insert the purchase order items info (depId, storageId etc)
                                            if(result.data.data) {
                                                // structure is [[POIId, POId, Num, DepId, StorageId]]
                                                let postItemListInfoData = [];
                                                let poId;
        
                                                let pendingDataPOInfo = this.props.pendingDataPOInfo.filter( (obj) => obj.supplierId === this.props.match.params.supplierId)[0].data;
        
                                                pendingDataPOInfo.forEach((product, index) => {
                                                    let obj = result.data.data.filter((item) => {
                                                        return item.GoodsId === product.GoodsId && item.GoodsFormatId === product.GoodsFormatId
                                                    })[0];
        
                                                    if(obj) {
                                                        poId = obj.POId;
                                                        postItemListInfoData.push([obj.POIId, obj.POId, toFixed(product.Num,DECIMALS_5), product.DepId, 0]);
                                                    }
                                                });
        
                                                axios({
                                                    method: 'post',
                                                    url: `${process.env.REACT_APP_API_URL_MODEL}/api/getItemListInfo`,
                                                    data: {
                                                      data:JSON.stringify(postItemListInfoData)
                                                    },
                                                    headers: {
                                                        operatorid:this.state.data.OperatorId,
                                                        branchid:this.state.data.BranchId,
                                                        sessionkey:sessionKey
                                                    }
                                                  }).then((result) => {

                                                    axios({
                                                      method: 'post',
                                                      url: `${process.env.REACT_APP_API_URL_PO_LOGGING_POST}`,
                                                      headers: {
                                                          Authorization: 'Basic ' + this.props.auth.token
                                                        },
                                                      data: {
                                                          "poAudit": {
                                                              "poId": poId,
                                                              'tmId': this.props.match.params.poId,
                                                              "platform": 1,
                                                              "mode": this.props.auth.mode === 'supplier' ? 2 : 1,
                                                              "operatorId":this.props.auth.operatorId,
                                                              "operator":this.props.auth.operatorName,
                                                              "action": 2
                                                          }
                                                        }
                                                      })        
                                                    .then((res) => {

                                                        if(this.props.auth.autoReceipt) {
                                                            // Auto Receipt
                                                            let receiptParams = {
                                                                poId:poId,
                                                                state:2,
                                                                mediaId:'',
                                                                remark:this.getSanitizeRemark(),
                                                                goodsList:goodsListReceipt
                                                            }
                                                            axios.post(`${process.env.REACT_APP_API_URL_RECEIPT}`, {
                                                            query: `
                                                                    mutation foo($poId:Int!, $state:Int!, $mediaId:String, $remark:String, $goodsList:[GoodsList!]!) {
                                                                        addOrder(poId:$poId, state:$state, mediaId:$mediaId, remark:$remark, goodsList:$goodsList) { 
                                                                            responseCode
                                                                            responseMsg
                                                                            data {
                                                                                rlId
                                                                                rlOrderName
                                                                            }
                                                                        }
                                                                    }
                                                                `,
                                                            variables: receiptParams,
                                                            },{
                                                                headers: {
                                                                    operatorid:this.state.data.OperatorId,
                                                                    branchid:this.state.data.BranchId,
                                                                    sessionkey:sessionKey,
                                                                    'Content-Type': 'application/json'
                                                                }
                                                            }).then((res) => {
    
                                                                // update the receipt storageDate
                                                                axios.post(`${process.env.REACT_APP_API_URL}/api/setReceiptStorageDate`,{
                                                                    poId:poId,
                                                                    date:`${moment(this.state.data.deliveryDate).format("YYYY-MM-DD")} 00:00:00`
                                                                },{
                                                                    headers: {
                                                                        "Authorization": 'Basic ' + this.props.auth.token, //the token is a variable which holds the token      
                                                                    }
                                                                }).then( (response) => {
    
                                                                    // delete the successful POs
                                                                    axios.post(`${process.env.REACT_APP_API_URL_MODEL}/api/deleteOrder`,{
                                                                        poId:JSON.stringify(this.state.data.POId)
                                                                    },{
                                                                        headers: {
                                                                            operatorid:this.state.data.OperatorId,
                                                                            branchid:this.state.data.BranchId,
                                                                            sessionkey:sessionKey
                                                                        }
                                                                    }).then( (response) => {
                                                                        if(depNum === productInfoDepartments.length) {
                                                                            this.setState({
                                                                                isLoading:false,
                                                                                errorAPI:false,
                                                                                confirmPOSuccessful:true,
                                                                                orderName:orderName,
                                                                                orderNames:orderNames
                                                                            });   
                                                                        }
    
                                                                    }).catch( (err) => {
                                                                      this.handleServerErrorAPI(err);
                                                                    });
    
    
                                                                }).catch( (err) => {
                                                                  this.handleServerErrorAPI(err);
                                                                });
    
                                                            }).catch((err) => {
                                                              this.handleServerErrorAPI(err);
                                                            });
                                                        } else {
    
                                                            // delete the successful POs
                                                            axios.post(`${process.env.REACT_APP_API_URL_MODEL}/api/deleteOrder`,{
                                                                poId:JSON.stringify(this.state.data.POId)
                                                            },{
                                                                headers: {
                                                                    operatorid:this.state.data.OperatorId,
                                                                    branchid:this.state.data.BranchId,
                                                                    sessionkey:sessionKey
                                                                }
                                                            }).then( (response) => {
                                                                if(depNum === productInfoDepartments.length) {
                                                                    this.setState({
                                                                        isLoading:false,
                                                                        errorAPI:false,
                                                                        confirmPOSuccessful:true,
                                                                        orderName:orderName,
                                                                        orderNames:orderNames
                                                                    });   
                                                                }
    
                                                            }).catch( (err) => {
                                                              this.handleServerErrorAPI(err);
                                                            });
    
                                                        } // end isAutoReceipt

                                                    })
                                                    .catch((err) => {
                                                      this.handleServerErrorAPI(err); 
                                                    });


                                          
                                                  }).catch((err) => {
                                                    this.handleServerErrorAPI(err);
                                                  });
                                                
                                            } else {
                                              this.handleErrorAPI();                             
                                            }
                                        }).catch((err) => {
                                          this.handleServerErrorAPI(err);
                                        })
                                    })();
        
                                } else {
                                  this.handleErrorAPI();
                                }
                            })
                            .catch((err) => {
                              this.handleServerErrorAPI(err);
                            });
                        })();

                    depNum++;    
                    
                });
                
                /*
                this.state.data.purchaseOrderItemList.forEach((product) => {
                               
                    let num = parseFloat(product.Num).toFixed(2);
                    let salesPrice = parseFloat(product.salesPrice).toFixed(2);

                    if(num > 0) {
                        goodsList.push({
                            goodsId:product.GoodsId,
                            num:parseFloat(num),
                            goodsFormatId:product.GoodsFormatId,
                            sortVal:0,
                            salesPrice:parseFloat(salesPrice)
                        });

                        goodsListReceipt.push({
                            goodsId: product.GoodsId,
                            goodsFormatId: product.GoodsFormatId,
                            storageNum:parseFloat(num),
                            isExtra: 0,
                            state: 2,
                            price:parseFloat(salesPrice)         
                        });
                    }
                });
                */

            } else {
              this.handleErrorAPI();
            }

        }).catch( (err) => {
          this.handleServerErrorAPI(err);
        });
    });
      
  }

  handleClickRejectPurchaseOrder = () => {
    this.setState({
      showAlertModal: true,
      alertModalConfig: {
        title:(<><I18N type="ui" path="PURCHASE_ORDER" def="Purchase Order"/><> - </><I18N type="ui" path="REJECT" def="Reject"/></>),
        warning:(<><I18N type="ui" path="REJECT_PURCHASE_ORDER" def="Reject Purchase Order"/><>?</></>),
        function: this.handleRejectPO,
      },
    });
  };

  handleRejectPO = () => {
    this.setState(
      {
        isLoading: true,
      },
      () => {
        axios
          .post(
            `${process.env.REACT_APP_API_URL}/api/setPOState/`,
            {
              poId: JSON.stringify(this.state.data.POId),
              state: 4,
            },
            {
              headers: {
                Authorization: "Basic " + this.props.auth.token, //the token is a variable which holds the token
              },
            }
          )
          .then(() => {
            axios({
              method: "post",
              url: `${process.env.REACT_APP_API_URL_PO_LOGGING_POST}`,
              headers: {
                Authorization: "Basic " + this.props.auth.token,
              },
              data: {
                poAudit: {
                  poId: this.state.data.POId,
                  platform: 1,
                  mode: this.props.auth.mode === "supplier" ? 2 : 1,
                  operatorId:this.props.auth.operatorId,
                  operator:this.props.auth.operatorName,
                  action: 3,
                },
              },
            })
              .then((res) => {
                this.setState({
                  isLoading: false,
                  errorAPI: false,
                  rejectPOSuccessful: true,
                });
              })
              .catch((err) => {
                this.handleServerErrorAPI(err);
              });
          })
          .catch((err) => {
            this.handleServerErrorAPI(err);
          });
      }
    );
  };

  getSupplierDetailsProperty = (prop) => {
    if (!this.state.data.supplierDetails) {
      return "";
    } else {
      return this.state.data.supplierDetails[prop];
    }
  };

  getOperator = (OperatorId) => {
    let operator = this.state.data.operatorDetails.filter(
      (operator) => operator.OperatorId === OperatorId
    )[0];
    return operator;
  };

  getPOStateTitle = () => {
    if (this.state.data.State === 1) {
      return <I18N type="ui" path="PENDING_APPROVAL" def="未經批准"/>;
    } else if (this.state.data.State === 4) {
      return <I18N type="ui" path="REJECTED" def="拒絕了"/>;
    }
    return;
  };

  getOperatorName = (OperatorId) => {
    let operator = this.getOperator(OperatorId);
    if (operator) {
      let salutation = operator.Sex ? this.state.i18n["MR"] : this.state.i18n["MISS"];
      return `${salutation} ${operator.LastName}, ${operator.FirstName}`;
    }

    /*
    let operator = this.getOperator(OperatorId);
    if (operator) {
      return (
        <>
          <>
          {
            operator.Sex
            ? 
            <I18N type="ui" path="MR" def="先生"/> 
            : 
            <I18N type="ui" path="MISS" def="小姐"/>
          }
          </>
          <>
            {" "}
          </>
          <>
            {`${operator.LastName}, ${operator.FirstName}`}
          </>
        </>
      )
    }
    */
  };

  getOperatorMobile = () => {
    let operator = this.getOperator(this.state.data.OperatorId);
    if (operator) {
      return operator.Mobile;
    }
  };

  handleOnSelectOperator = (value) => {
    let data = JSON.parse(JSON.stringify(this.state.data));
    data.OperatorId = parseInt(value);
    if (value) {
      this.setState({
        data: data,
      });
    }
  };

  htmlDropdownOperatorOptions = () => {
    return this.state.data.operatorDetails.map((row, index) => {
      return (
        <Dropdown.Item as="button" key={index} eventKey={row.OperatorId}>
          {this.getOperatorName(row.OperatorId)}
        </Dropdown.Item>
      );
    });
  };

  htmlGetRemarks = () => {
    if (this.state.data.Remark) {
      return this.state.data.Remark;
    } else {
      return this.getRemark();
    }
  };

  getRemark = () => {
    let remark = "";
    this.state.data.remarkDetails.forEach((row, index) => {
      if (row.Remark) {
        if (!remark) {
          remark = `${row.Remark} (${this.getOperatorName(row.OperatorId)})`;
        } else {
          remark =
            remark +
            `\n\n${row.Remark} (${this.getOperatorName(row.OperatorId)})`;
        }
      }
    });
    return remark;
  };

  getSanitizeRemark = () => {
    let maxLength = 200;
    let str = this.htmlGetRemarks().toString();
    if (str.length > maxLength) {
      return str.substring(0, maxLength - 2) + "..";
    }
    return str;
  };

  handleOnChangeTextareaRemark = (e) => {
    let data = JSON.parse(JSON.stringify(this.state.data));
    data.Remark = e.currentTarget.value;
    this.setState({
      data: data,
    });
  };

  btnConfirmPurchaseOrderDisabled = () => {
    let disabled = false;

    //if(this.props.auth.consolidation) {
    let dataInfo = this.props.pendingDataPOInfo.filter(
      (obj) => obj.supplierId === this.props.match.params.supplierId
    )[0];
    let totalRows = dataInfo.data.length;
    if (
      dataInfo.data.filter((product) => product.Num === 0).length === totalRows
    ) {
      disabled = true;
    }
    //} else {
    //    let totalRows = this.state.data.purchaseOrderItemList.length;
    //    if(this.state.data.purchaseOrderItemList.filter( (product) => product.Num === 0).length === totalRows
    //    || this.state.data.purchaseOrderItemList.filter( (product) => product.Num && !product.salesPrice).length > 0) {
    //        disabled = true;
    //    }
    //}

    return disabled;
  };

  getDeliveryDate = () => {
    if (!this.state.data.deliveryDate) {
      let data = JSON.parse(JSON.stringify(this.state.data.poData));
      let datetime = data.sort(function (a, b) {
        return moment(a.StorageDate) - moment(b.StorageDate);
      })[0].StorageDate;

      if (moment(datetime).isBefore(moment(), "day")) {
        return moment();
      } else {
        return moment(datetime);
      }
    } else {
      return moment(this.state.data.deliveryDate);
    }
  };

  handleOnClickDeliveryDate = () => {
    console.log("clicked..");
  };

  handleDeliveryDateChange = (date) => {
    let data = JSON.parse(JSON.stringify(this.state.data));
    data.deliveryDate = date._d;
    this.setState(
      {
        data: data,
      },
      () => {
        //console.log(data);
      }
    );
  };

  htmlSingleDatePicker = () => {
    return (
      <SingleDatePicker
        date={this.getDeliveryDate()}
        onDateChange={(date) => this.handleDeliveryDateChange(date)}
        focused={this.state.focused}
        onFocusChange={({ focused }) => this.setState({ focused })}
        id="deliveryDate"
        orientation={orientation}
        small={true}
        displayFormat="DD/MM/YYYY"
      />
    );
  };

  handleClickLogs = () => {
    this.setState({
      isLogs: !this.state.isLogs,
    });
  };

/*
  (Return) Warning Labels
*/

getWarnings = () => {
    if(this.state.warnings.sellPrice.length) {

      let li = [];

      // Warnings SellPrice
      this.state.warnings.sellPrice.forEach( (obj) => {
        let item = this.getSupplierInventoryItem(obj.goodsId, obj.goodsFormatId);
        //let label = `${obj.goodsName} 單價 $${obj.salesPrice} 自動更新單價為 $${item.SellPrice}`;

          li.push(
            <li>
              <I18N 
                type="ui" 
                path="PRODUCT_WARNING_PRICING" 
                def={`${obj.goodsName} 單價 $${obj.salesPrice} 自動更新單價為 $${item.SellPrice}`} 
                replace={{
                    "GOODSNAME":{
                      "goodsId":obj.goodsId,
                      "goodsName":obj.goodsName
                    },
                    "SALESPRICE":obj.salesPrice,
                    "SELLPRICE":item.SellPrice
                  }}
              />
            </li>);
      });
      
      // Warnings Inactive
      this.state.warnings.inactive.forEach( (obj) => {
        let label =  `${obj.goodsName} 已停用，數量自動更新為 0`;
        li.push(
          <li>
            <I18N 
              type="ui" 
              path="PRODUCT_WARNING_INACTIVE" 
              def={label}
              replace={{
                "GOODSNAME":{
                  "goodsId":obj.goodsId,
                  "goodsName":obj.goodsName
                }
              }}
            />
          </li>
        );
      });

      //return `<ul class='m-0'>${li}<ul>`;
      
      let html = li.map( (component, i) => {
        return component
      });

      return <ul>{html}</ul>
    }
    return;
  }

// (Boolean) Is Loading
  isLoading = () => {
    if(this.state.isLoading) {
      return true;
    }
    return false;
  }

  seti18n = () => {
    [{
        type:'ui',
        path:'ORDER_WARNING',
        def:'訂單提示'
    },{
      type:'ui',
      path:'PRODUCT_NAME',
      def:'貨品名稱'
    },{
      type:'ui',
      path:'MR',
      def:'先生'
    },{
      type:'ui',
      path:'MISS',
      def:'先生'
    }].forEach( (obj) => {
        i18n(obj.type,obj.path,obj.def).then((value) => {
            let i18n = JSON.parse(JSON.stringify(this.state.i18n));
            i18n[obj.path] = value;
            this.setState({
                i18n:i18n
            });
        });    
    });
  }

  /* 
  NavbarComponent onClick Callback
  */

 onClickNavBarLocale =  () => {
    this.seti18n();
  }

  render() {

    return (
      <>
        <Container className="p-0 mb-5">
          {!this.isShareView() && !this.isPrint() && <NavbarComponent
           onClickLocale={this.onClickNavBarLocale}
           />}
          <Container fluid>
            {this.state.authError || this.state.serverError ? (
              <Row className="mt-4">
                <Col xs={12}>
                  <>
                    <h1>{this.getPOStateTitle()} - <I18N type="ui" path="PURCHASE_ORDER" def="採購單"/></h1>
                    {this.state.authError && <AuthErrorComponent />}
                    {this.state.serverError && <ServerErrorComponent />}
                  </>
                </Col>
              </Row>
            ) : this.isLoading() ? (
              <LoadingComponent />
            ) : (
              <>
                <Row className="mt-4">
                  <Col xs={12} sm={6}></Col>
                  {!this.isShareView() && !this.isPrint() && (
                    <Col xs={12} sm={6} className="text-right">
                      <Button
                        variant="link"
                        className="px-0 mr-4"
                        onClick={this.handleGoBack}
                      >
                        <ArrowLeftCircle size={16} className="mb-1 mr-1" /> <I18N type="ui" path="GO_BACK" def="Go Back"/>
                      </Button>
                      <Button
                        variant="link"
                        className="px-0 mr-2"
                        onClick={() => this.handleClickLogs()}
                      >
                        <Binoculars size={16} className="mb-1 mr-1" /> <I18N type="ui" path="LOGS" def="Logs"/>
                      </Button>
                    </Col>
                  )}
                </Row>
                <Row>
                <Col sm={8}>
                        <div className="font-weight-bold mb-1">
                          <I18N 
                              type={BRANCHES} 
                              value={{
                                  "businessId":this.props.auth.businessId,
                                  "branchId":this.state.data.branchDetails.BranchId
                              }} 
                              property="BranchName" 
                              def={this.state.data.branchDetails.BranchName}
                          />
                        </div>
                      </Col>
                      <Col sm={4} className="text-right justify-content-end">
                        <div>
                          <h4 className="d-inline-block text-primary mt-2 border-bottom border-primary">
                            {this.getPOStateTitle()} - <I18N type="ui" path="PURCHASE_ORDER" def="採購單"/>
                          </h4>
                        </div>
                        <div className="font-weight-bold">
                          <div><I18N type="ui" path="PURCHASE_ORDER_NUMBER" def="採購單號"/>: {`${this.state.data.OrderName}`}</div>
                          <div>
                          <I18N type="ui" path="ORDER_DATE" def="採購日期"/>:{" "}
                            {moment(this.state.data.CreateDate).format(
                              "D MMM YYYY"
                            )}
                          </div>
                          <div>
                          <I18N type="ui" path="DELIVERY_DATE" def="送貨日期"/>:{" "}
                            {!this.state.isEdit
                              ? moment(this.state.data.StorageDate).format(
                                  "D MMM YYYY"
                                )
                              : this.htmlSingleDatePicker()}
                          </div>
                          <div><I18N type="ui" path="CURRENCY" def="貨幣"/>: <I18N type="ui" path="HKD" def="港元"/></div>
                        </div>
                      </Col>
                  {!this.isPrint() &&
                    !this.state.confirmPOSuccessful &&
                    !this.state.rejectPOSuccessful && (
                      <Col xs={12} sm={6} className="text-right">
                      </Col>
                    )}
                </Row>
                <Row className="mt-4">
                  <Col xs={12}>
                    {this.state.saveSuccessful && (
                      <AlertSuccessComponent label={
                        <I18N type="ui" path="SAVE_PURCHASE_ORDER_SUCCESSFUL" def="Save Purchase Order Successful"/>
                       } />
                    )}
                    {this.state.addProductSuccessful && (
                      <AlertSuccessComponent label={
                        <I18N type="ui" path="ADD_PRODUCT_SUCCESSFUL" def="Add Product Successful"/>
                      } />
                    )}
                    {this.state.confirmPOSuccessful && (
                      <AlertSuccessComponent
                        label={
                          <>
                            <I18N type="ui" path="CONFIRM_PURCHASE_ORDER_SUCCESSFUL" def="Confirm Purchase Order Successful"/>: 
                            {" "}
                            {this.state.orderNames.toString()}
                          </>
                        }
                      />
                    )}
                    {this.state.rejectPOSuccessful && (
                      <AlertSuccessComponent
                        label={<I18N type="ui" path="REJECT_PURCHASE_ORDER_SUCCESSFUL" def="Reject Purchase Order Successful"/>}
                      />
                    )}
                    {this.state.errorAPI && (
                      <AlertErrorComponent label={<I18N type="ui" path="BAD_REQUEST_400" def="Bad Request (400)"/>} />
                    )}

                    {(this.state.confirmPOSuccessful ||
                      this.state.rejectPOSuccessful) && (
                      <div className="mt-4 d-inline">
                        <Button
                          //block={!this.state.isDesktop}
                          id="btnGoBackApprovalPurchaseOrder"
                          variant="secondary"
                          className="dropdown d-inline-block"
                          onClick={this.handleGoBack}
                        >
                          <I18N type="ui" path="GO_BACK" def="Go Back"/>
                        </Button>
                      </div>
                    )}
                  </Col>
                </Row>
                {!this.state.confirmPOSuccessful &&
                  !this.state.rejectPOSuccessful && (
                    <>

                      {/* <Row>
                        <Col xs={12}>
                          <h3 className="text-info">
                            {this.state.data.branchDetails.BranchName}
                          </h3>
                          <div>{this.state.data.branchDetails.Address}</div>
                          {this.state.data.branchDetails.PhoneNum && (
                            <div>
                              <span className="font-weight-bold text-secondary">
                                電話:
                              </span>{" "}
                              {this.state.data.branchDetails.PhoneNum}
                            </div>
                          )}
                          {this.state.data.branchDetails.fax && (
                            <div>
                              <span className="font-weight-bold text-secondary">
                                傳真:
                              </span>{" "}
                              {this.state.data.branchDetails.fax}
                            </div>
                          )}
                        </Col>
                      </Row> */}

                      <Row>
                        <Col sm={12} md={4} className="mt-4">
                          <div>
                            <h5 className="text-primary mb-2"><I18N type="ui" path="SUPPLIER" def="供應商"/></h5>
                          </div>
                          <div className="font-weight-bold mb-1">
                            <I18N 
                              type={SUPPLIERS}
                              value={this.getSupplierDetailsProperty("supplierId")} 
                              def={this.getSupplierDetailsProperty("supplierName")} 
                              property="SupplierName"
                            />
                          </div>
                          <div>
                            <I18N 
                              type={SUPPLIERS}
                              value={this.getSupplierDetailsProperty("supplierId")} 
                              def={this.getSupplierDetailsProperty("address")} 
                              property="Address"
                            />
                          </div>

                          {this.getSupplierDetailsProperty("phone") && (
                            <div>
                              <I18N type="ui" path="PHONE" def="電話"/>: {""}
                              {this.getSupplierDetailsProperty("phone")}
                            </div>
                          )}

                          {this.getSupplierDetailsProperty("fax") && (
                            <div>
                              <I18N type="ui" path="FAX" def="傳真"/>: {""}
                              {this.getSupplierDetailsProperty("fax")}
                            </div>
                          )}

                          {this.getSupplierDetailsProperty("email") && (
                            <div>
                              <I18N type="ui" path="EMAIL" def="電郵"/>: {""}
                              <span className="text-break">
                                {this.getSupplierDetailsProperty("email")}
                              </span>
                            </div>
                          )}
                        </Col>
                        <Col sm={12} md={4} className="mt-4">
                          <div>
                            <h5 className="text-primary mb-2"><I18N type="ui" path="DELIVERY_ADDRESS" def="送貨地址"/></h5>
                          </div>
                          <div className="font-weight-bold mb-1">
                            <I18N 
                              type={BRANCHES} 
                              value={{
                                  "businessId":this.props.auth.businessId,
                                  "branchId":this.state.data.branchDetails.BranchId
                              }} 
                              property="BranchName" 
                              def={this.state.data.branchDetails.BranchName}
                            />
                          </div>
                          <div>
                            <I18N 
                              type={BRANCHES} 
                              value={{
                                  "businessId":this.props.auth.businessId,
                                  "branchId":this.state.data.branchDetails.BranchId
                              }} 
                              property="Address" 
                              def={this.state.data.branchDetails.Address}
                            />
                          </div>
                          {this.props.auth.consolidation === false && (
                            <div className="mt-2">
                              <>
                              <span><I18N type="ui" path="DEPARTMENT" def="部門"/>: </span>
                              <I18N 
                              type={DEPARTMENTS} 
                              value={{
                                "businessId":this.props.auth.businessId,
                                "branchId":this.state.data.branchDetails.BranchId,
                                "depId":this.state.data.DepId
                              }} 
                              property="DepName" 
                              def={this.state.data.DepName}
                              />
                              </>
                            </div>
                          )}
                          <div>
                            <I18N type="ui" path="CONTACT_PERSON" def="聯絡人"/>:{" "}
                            {this.state.data.operatorDetails.length > 1 ? (
                              <div className="d-inline">
                                <DropdownButton
                                  id={`dropdown-operator`}
                                  variant="secondary"
                                  title={this.getOperatorName(
                                    this.state.data.OperatorId
                                  )}
                                  size="sm"
                                  onSelect={(value) =>
                                    this.handleOnSelectOperator(value)
                                  }
                                  className="dropdown d-inline-block"
                                >
                                  <Dropdown.Item as="button" eventKey="">
                                    <I18N type="ui" path="SELECT_OPERATOR" def="Select Operator"/>
                                  </Dropdown.Item>
                                  {this.htmlDropdownOperatorOptions()}
                                </DropdownButton>
                              </div>
                            ) : (
                              <span>
                                {this.getOperatorName(
                                  this.state.data.OperatorId
                                )}
                              </span>
                            )}
                          </div>
                          <div><I18N type="ui" path="PHONE" def="電話"/>: {this.getOperatorMobile()}</div>
                        </Col>
                        <Col xs={12} sm={4} className="mt-4 col-4-print">
                          <h5 className="text-primary mb-2"><I18N type="ui" path="INVOICE" def="發票"/></h5>
                          <div><I18N type="ui" path="INVOICE_INSTRUCTIONS" def="發票寄至財務部應付賬款"/></div>
                        </Col>
                      </Row>

                      {this.getWarnings() &&
                        <Row>
                          <Col className="mt-4">
                            <AlertComponent
                              variant="warning"
                              label={this.state.i18n["ORDER_WARNING"]}
                              body={this.getWarnings()}
                            />
                          </Col>
                        </Row>
                      }

                      {!this.isReadOnly() && (
                        <Row className="mt-4">
                          <Col xs={6}>
                            <Button onClick={this.handleOpenAddProductModal}>
                              <I18N type="ui" path="ADD_PRODUCT" def="Add Product"/>
                            </Button>
                          </Col>
                          {this.state.poTouched && (
                            <Col xs={6} className="text-right">
                              <Button
                                variant="link"
                                onClick={this.handleToggleUndoModal}
                              >
                                <XCircle size={16} className="mb-1 mr-1" />
                                <I18N type="ui" path="UNDO_CHANGES" def="Undo Changes"/>
                              </Button>
                            </Col>
                          )}
                        </Row>
                      )}

                      <Row className="mt-4">
                        <Col xs={12}>{this.htmlPurchaseOrderTable()}</Col>
                      </Row>

                      <Row className="mt-4">
                        <Col xs={12} sm={8}>
                          <div>
                            <span className="font-weight-bold text-secondary">
                            <I18N type="ui" path="REMARKS" def="備註"/> (<I18N type="ui" path="SUPPLIER" def="供方"/>):
                            </span>
                            <textarea
                              className="form-control mt-2"
                              id="textarea-remarks"
                              rows="10"
                              onChange={this.handleOnChangeTextareaRemark}
                              value={this.htmlGetRemarks()}
                            ></textarea>
                          </div>
                        </Col>
                        <Col xs={12} sm={4}>
                        <div className="mt-2 py-2">
                              <div className="text-right font-weight-bold">
                                <span><I18N type="ui" path="SUBTOTAL" def="小計"/>:</span>{" "}
                                {formatCurrency(this.htmlSubTotal())}
                              </div>
                              <hr className="my-2" />
                              <div className="text-right font-weight-bold">
                                <span><I18N type="ui" path="TOTAL" def="合計"/>:</span>{" "}
                                {formatCurrency(this.htmlTotal())}
                              </div>
                            </div>
                          <div className="text-right mt-4">
                            <Button
                              //{!this.state.isDesktop}
                              id="btnConfirmPurchaseOrder"
                              variant="success"
                              disabled={
                                this.btnConfirmPurchaseOrderDisabled()
                                  ? true
                                  : false
                              }
                              onClick={this.handleClickConfirmPurchaseOrder}
                            >
                              <I18N type="ui" path="CONFIRM_PURCHASE_ORDER" def="Confirm Purchase Order"/>
                            </Button>
                          </div>
                          <div className="text-right mt-4">
                            <Button
                              //block={!this.state.isDesktop}
                              id="btnRejectPurchaseOrder"
                              variant="danger"
                              disabled={
                                this.state.isSavePurchaseOrder ? true : false
                              }
                              onClick={this.handleClickRejectPurchaseOrder}
                            >
                              <I18N type="ui" path="REJECT_PURCHASE_ORDER" def="Reject Purchase Order"/>
                            </Button>
                          </div>
                        </Col>
                      </Row>

                      {/* Footer */}
                      <Row>
                        <div className="d-flex mt-5 align-items-end">
                          <div className="d-flex align-items-end">
                            <div id="logo-horus">
                              <img
                                src="/assets/images/logo_horus.png"
                                width="80"
                                alt=""
                              ></img>
                            </div>
                            <div className="powered-by mt-5 ms-4">
                              <I18N type="ui" path="HORUS_TAGLINE" def="此採購單由Horus提供技術支援"/>
                            </div>
                          </div>
                          {/*
                          <div className="ms-auto align-items-end text-right">
                            <div className="d-flex flex-row-reverse align-items-end">
                              <div id="qr-code">
                              <img
                                src="/assets/images/qr-code.svg"
                                width="80"
                                alt=""
                              ></img>
                              </div>
                              <div className="qr-details me-4">
                                <I18N type="ui" path="SCAN_QR_CODE_1" def="閣下可掃描二維碼"/>
                                <br />
                                <I18N type="ui" path="SCAN_QR_CODE_2" def="瀏覽此採購單詳情"/>
                              </div>
                            </div>
                          </div>
                          */}
                        </div>
                      </Row>


                      {!this.isReadOnly() && (
                        <Row className="mb-4">
                          {/*
                                <Col xs={12} sm={6}>
                                    <div className="mt-4">
                                        <Button 
                                            block={!this.state.isDesktop}
                                            id="btnSavePurchaseOrder"
                                            variant="warning"
                                            onClick={this.handleClickSavePurchaseOrder}
                                            //disabled={!this.state.isSavePurchaseOrder}
                                            >
                                            Save Purchase Order
                                        </Button>
                                    </div>
                                </Col>
                                */}
                          <Col xs={12} className="mt-4 text-sm-right"></Col>
                        </Row>
                      )}
                      {!this.isReadOnly() && this.htmlAddProduct()}
                      {!this.isReadOnly() && this.htmlEmail()}
                      {!this.isReadOnly() && this.htmlAlertModal()}
                      {!this.isReadOnly() && this.htmlUndoChanges()}
                    </>
                  )}
              </>
            )}
          </Container>
        </Container>
        {this.state.isLogs && (
          <LogsModalComponent
            isLogs={this.state.isLogs}
            poId={this.state.data.POId}
            handleClickLogs={this.handleClickLogs}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = state => {
    const {auth, pendingDataPOInfo} = state;
    return { 
        auth: auth,
        pendingDataPOInfo: pendingDataPOInfo
    };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PurchaseOrder));
